// extracted by mini-css-extract-plugin
module.exports = {"container":"_1XgdPjqbh5ycLpW8nojDev","image":"_6YL4CS_H9D3yG50ihnvGE"};